import ClientItem from "./client-item";

export default ClientItem